import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RoomCard = ({ room, onEdit, onDuplicate, onDelete, onPreview }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden transition-all duration-150 hover:shadow-lg group">
      <div className="relative aspect-video bg-muted overflow-hidden">
        <Image
          src={room?.backgroundImage}
          alt={room?.backgroundImageAlt}
          className={`w-full h-full object-cover transition-all duration-300 group-hover:scale-105 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onLoad={() => setImageLoaded(true)}
        />
        {!imageLoaded && (
          <div className="absolute inset-0 flex items-center justify-center">
            <Icon name="Image" size={32} className="text-text-secondary animate-pulse" />
          </div>
        )}
        
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-150" />
        
        <button
          onClick={() => onPreview(room)}
          className="absolute top-3 right-3 w-10 h-10 bg-surface/90 backdrop-blur-sm border border-border rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-150 hover:bg-surface"
          aria-label="Preview room"
        >
          <Icon name="Eye" size={18} />
        </button>

        {room?.isDefault && (
          <div className="absolute top-3 left-3 px-2 py-1 bg-primary text-primary-foreground text-xs font-medium rounded">
            Default
          </div>
        )}
      </div>
      <div className="p-4 space-y-3">
        <div>
          <h3 className="text-base font-semibold text-text-primary mb-1 line-clamp-1">
            {room?.name}
          </h3>
          <div className="flex items-center gap-2 text-sm text-text-secondary">
            <Icon name="Tag" size={14} />
            <span>{room?.category}</span>
          </div>
        </div>

        {room?.dimensions && (
          <div className="flex items-center gap-2 text-xs text-text-secondary">
            <Icon name="Ruler" size={12} />
            <span>{room?.dimensions}</span>
          </div>
        )}

        <div className="flex items-center justify-between pt-2 border-t border-border">
          <div className="flex items-center gap-1 text-xs text-text-secondary">
            <Icon name="Users" size={14} />
            <span>{room?.usageCount} selections</span>
          </div>

          <div className="flex items-center gap-1">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onEdit(room)}
              iconName="Edit2"
              iconSize={14}
              className="h-8 w-8 p-0"
              aria-label="Edit room"
            />
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDuplicate(room)}
              iconName="Copy"
              iconSize={14}
              className="h-8 w-8 p-0"
              aria-label="Duplicate room"
            />
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDelete(room)}
              iconName="Trash2"
              iconSize={14}
              className="h-8 w-8 p-0 text-error hover:text-error"
              aria-label="Delete room"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomCard;